const prev = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39"><circle cx="19.5" cy="19.5" r="19" fill="#fff" stroke="#ff9d6c" stroke-miterlimit="10" /><polyline points="23.556 7.388 11.444 19.5 23.556 31.612" fill="none" stroke="#ff9d6c" stroke-linecap="round" stroke-miterlimit="10" /></svg>';
const next = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39"><circle cx="19.5" cy="19.5" r="19" fill="#fff" stroke="#ff9d6c" stroke-miterlimit="10" /><polyline points="15.444 7.388 27.556 19.5 15.444 31.612" fill="none" stroke="#ff9d6c" stroke-linecap="round" stroke-miterlimit="10" /></svg>';

document.addEventListener( 'DOMContentLoaded', () => {

	const dailyLife = document.getElementById( 'daily-life-carousel' );
	const explainingPnh = document.getElementById( 'explaining-pnh-carousel' );
	const additionalTests = document.getElementById( 'additional-tests-carousel' );
	const livingWell = document.getElementById( 'living-well-carousels' );
	const quotes = document.getElementById( 'quote-carousel' );
	const homepageQuotes = document.getElementById( 'homepage-quote-carousel' );

	const resourceCarousels = document.querySelectorAll( '[data-resource-carousel]' );
	resourceCarousels.forEach( carousel => {
		const dailyLifeCarousel = new Carousel( {
			elem: `#${carousel.id}`,
			autoplay: false,
			infinite: true,
			interval: 10000,
			initial: 0,
			dots: true,
			arrows: false,
			buttons: false,
			btnStopText: 'Pause',
			arrPrevText: prev,
			arrNextText: next
		} );
	} );

	if ( dailyLife ) {
		const dailyLifeCarousel = new Carousel( {
			elem: '#daily-life-carousel',
			autoplay: true,
			infinite: true,
			interval: 10000,
			initial: 0,
			dots: false,
			arrows: true,
			buttons: false,
			btnStopText: 'Pause',
			arrPrevText: prev,
			arrNextText: next
		} );
	}

	if ( explainingPnh ) {
		const explainingPnhCarousel = new Carousel( {
			elem: '#explaining-pnh-carousel',
			autoplay: true,
			infinite: true,
			interval: 10000,
			initial: 0,
			dots: false,
			arrows: true,
			buttons: false,
			btnStopText: 'Pause',
			arrPrevText: prev,
			arrNextText: next
		} );
	}

	if ( livingWell ) {
		const livingWellCarousel = new Carousel( {
			elem: '#living-well-carousel',
			autoplay: false,
			infinite: true,
			interval: 10000,
			initial: 0,
			dots: false,
			arrows: true,
			buttons: false,
			btnStopText: 'Pause',
			arrPrevText: prev,
			arrNextText: next
		} );
	}

	if ( additionalTests ) {
		const additionalTestsCarousel = new Carousel( {
			elem: '#additional-tests-carousel',
			autoplay: true,
			infinite: true,
			interval: 10000,
			initial: 0,
			dots: false,
			arrows: true,
			buttons: false,
			btnStopText: 'Pause',
			arrPrevText: prev,
			arrNextText: next
		} );
	}

	if ( quotes ) {
		const dailyLifeQuoteCarousel = new Carousel( {
			elem: '#quote-carousel',
			autoplay: true,
			infinite: true,
			interval: 8000,
			initial: 0,
			dots: true,
			arrows: false,
			buttons: false,
			btnStopText: 'Pause',
			arrPrevText: prev,
			arrNextText: next
		} );
	}

	if ( homepageQuotes ) {
		const homepageQuoteCarousel = new Carousel( {
			elem: '#homepage-quote-carousel',
			autoplay: true,
			infinite: true,
			interval: 8000,
			initial: 0,
			dots: true,
			arrows: false,
			buttons: false,
			btnStopText: 'Pause',
			arrPrevText: prev,
			arrNextText: next
		} );
	}

} );

/**
 * Makes the slider responsive.
 * Recalculates slide widths based on the dynamic container.
 *
 * @param {boolean} resize Whether or not the calculation is triggered from a resize event.
 */
function calculateSlideWidth( resize = false ) {

	const carousels = document.querySelectorAll( '[data-carousel]' );
	carousels.forEach( carousel => {
		const width = carousel.clientWidth;
		const firstSlide = carousel.querySelector( '[data-carousel-slide]' );
		const slides = carousel.querySelectorAll( '[data-carousel-slide]' );
		const heights = [];
		slides.forEach( slide => {
			slide.style.width = `${width}px`;
			slide.style.minWidth = `${width}px`;
			heights.push( slide.offsetHeight );
			if ( slide.dataset.backgroundImage ) {
				console.log( slide.dataset.backgroundImage );
				slide.style.backgroundImage = `url(${slide.dataset.backgroundImage})`;
				slide.style.minHeight = '554px';
			}
		} );
		if ( resize ) {
			firstSlide.style.marginLeft = `-${width}px`;
		}
	} );

}

calculateSlideWidth();

window.addEventListener( 'resize', () => {
	calculateSlideWidth( true );
} );
